import React from "react";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";

export default function DateInput(props) {
  const mask = [
    /[0-9]/,
    /[0-9]/,
    ".",
    /[0-9]/,
    /[0-9]/,
    ".",
    /[12]/,
    /[890]/,
    /[0-9]/,
    /[0-9]/
  ];
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd.mm.yyyy");

  return (
    <MaskedInput
      mask={mask}
      type="text"
      // placeholderChar=" "
      guide={false}
      keepCharPositions={true}
      pipe={autoCorrectedDatePipe}
      {...props}
    />
  );
}

// import React from "react";
// import MaskedInput from "react-maskedinput";
//
// function DateInput(props) {
//   return (
//     <MaskedInput
//       mask="21.31.4511"
//       placeholder="  .  ."
//       placeholderChar=" "
//       {...props}
//       formatCharacters={{
//         2: {
//           validate: char => /[0123]/.test(char),
//           transform: char => (char === " " ? "" : char)
//         },
//         3: {
//           validate: char => /[01]/.test(char),
//           transform: char => (char === " " ? "" : char)
//         },
//         4: {
//           validate: char => /[12]/.test(char),
//           transform: char => (char === " " ? "" : char)
//         },
//         5: {
//           validate: char => /[089]/.test(char),
//           transform: char => (char === " " ? "" : char)
//         }
//       }}
//     />
//   );
// }

// export default DateInput;
